import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAssistantList } from "../Redux/Slice/Assistant/AssistantsListSlice";
import { scheduleInstantCall } from "../Redux/Slice/Contacts/ScheduleInstantCallSlice";
import { Loader } from "../Common/Loader";
import { scheduleCallAction } from "../Redux/Slice/Contacts/CallActionSlice";
import { scheduleFormCallAction } from "../Redux/Slice/Contacts/FormCallActionSlice";

export const CallInstantModal = (props) => {
  const dispatch = useDispatch();
  const [assistants, setAssistants] = useState([]);
  const [selectedAssistant, setSelectedAssistant] = useState("");
  const AssistantList = useSelector((state) => state.assistants.assistantsList);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    FetchAssistantsList();
  }, []);

  const FetchAssistantsList = async () => {
    await dispatch(getAssistantList({ text: "", isDropdown: true }));
  };
  useEffect(() => {
    if (AssistantList && Array.isArray(AssistantList.data)) {
      setAssistants(AssistantList.data);
    }
  }, [AssistantList]);

  const handleChange = (e) => {
    const { value } = e?.target;
    setSelectedAssistant(value);
  };

  const handleSubmit = async () => {
    let body = {
      assistantId: selectedAssistant,
    };
    if (props?.isForContactGroup) {
      body.contactGroupIds = props?.isMultiple
        ? props?.contactsList()
        : [props?.currentContact?.id];
    } else if (props?.isForCallId) {
      body.callId = props?.isMultiple
        ? props?.contactsList()
        : [props?.currentContact?.id];
      body.action = "call"
    } else if (props?.isForForm) {
      body.contacts = props?.isMultiple
        ? props?.contactsList()
        : [props?.currentContact];
      body.action = "call"
    } else {
      body.contactIds = props?.isMultiple
        ? props?.contactsList()
        : [props?.currentContact?.id];
    }
    setIsLoading(true);

    try {
      const action = props?.isForCallId
        ? scheduleCallAction
        : props?.isForForm 
        ? scheduleFormCallAction
        : scheduleInstantCall;
      const result = await dispatch(action(body));
      if (action.fulfilled.match(result) && result?.payload?.success === true) {
        props.closePopup("success");
        setIsLoading(false);
      } else {
        props.closePopup("error", result?.payload?.error);
        setIsLoading(false);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="modal modal--createAssistant modal--open">
      <div className="modal__dialog">
        <div className="modal__content modal__content--md">
          <div className="modal__header">
            <h1 className="modal__header--title">Calling Details</h1>
            <p className="para">
              Please select the details below to call your assistant instantly
            </p>
          </div>
          <div className="modal__body  modal-body-left">
            <div className="scheduleCall scheduleCall--callingDetails">
              <div className="scheduleCall__row scheduleCall__row--divider"></div>
              <div className="scheduleCall__row">
                <div className="form__Field form__Field--full">
                  <label for="Chatbot" className="form__label">
                    Chatbot
                  </label>
                  <select
                    className="form__select form__select--sm"
                    id="Chatbot"
                    name="chatbotId"
                    value={selectedAssistant}
                    onChange={handleChange}
                  >
                    <option selected="" value="" disabled>
                      -Select-
                    </option>
                    {assistants
                      ? assistants.map((assistant) => (
                          <option value={assistant.id}>{assistant.name}</option>
                        ))
                      : ""}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="modal__footer">
            <div className="btn__group">
              <button onClick={props?.closePopup} className="btn btn__white">
                Cancel
              </button>
              <button
                className="btn btn__primary"
                disabled={!selectedAssistant}
                onClick={handleSubmit}
              >
                Call
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};
